module.exports = __webpack_public_path__ + "static/media/upload-logo.2f0c7e75.svg";